import { pick } from 'es-toolkit'

export default defineNuxtRouteMiddleware(async (to) => {
  const { isLoggedIn, user } = useAgsUser()
  const { showGoldnerClub } = useExperiments()
  const { data: membershipData, getMembershipDetails } = useGoldnerClub()
  const flatShippingOrderNumber = '40000'
  const flatShippingProductId = '30376'
  const isPdp = to.path.includes('/p/')
  const isRestrictedPdp =
    isPdp &&
    (to.query?.ordernumber === flatShippingOrderNumber ||
      to.params.id === flatShippingProductId)
  const inFreeShipping = user.value?.groups?.includes('free_shipping')

  if (import.meta.server && isLoggedIn) {
    await getMembershipDetails()
  }

  const localePath = (routePath: LinkList[keyof LinkList]['path']) => {
    const getLocalePath = useLocalePath()
    return getLocalePath(routePath) || routePath
  }

  const getProtectedRoutes = (exclude: (keyof LinkList)[] = []) => {
    const routes = Object.entries(
      pick(routeList, ['goldnerClub', 'goldnerClubSubscribePage']),
    ).reduce((routeMap, [name, value]) => {
      if (exclude.some((routeName) => routeName === name)) {
        return routeMap
      }

      Object.assign(routeMap, { [name]: value })
      return routeMap
    }, {} as Partial<LinkList>)

    return Object.values(routes).map((it) => localePath(it.path))
  }

  const isGolderClubDetailPage =
    to.path === localePath(routeList.goldnerClub.path)
  const isProtectedRoute = getProtectedRoutes().some((path) => to.path === path)

  if (isProtectedRoute && !showGoldnerClub.value) {
    return navigateTo({
      path: localePath(routeList.home.path),
    })
  }

  if (isGolderClubDetailPage && !membershipData.value?.isClubMember) {
    return navigateTo({
      path: localePath(routeList.goldnerClubSubscribePage.path),
      query: {
        redirectUrl: to.fullPath,
      },
    })
  }

  if (isRestrictedPdp) {
    if (!isLoggedIn.value) {
      return navigateTo({
        path: localePath(routeList.goldnerClubEntryPage.path),
        query: { redirectUrl: to.fullPath },
      })
    }

    if (!membershipData.value?.isClubMember && !inFreeShipping) {
      return navigateTo({
        path: localePath(routeList.goldnerClubSubscribePage.path),
        query: { redirectUrl: to.fullPath },
      })
    }

    if (inFreeShipping) {
      return navigateTo({
        path: localePath(routeList.goldnerClub.path),
      })
    }
  }
})
